module.exports = __webpack_public_path__ + "static/media/exportSingle.0611aa7b.svg";